/**
 * PoolDisplay.js
 *
 * Shared component for displaying gift pool visuals.
 * Handles two distinct pool types:
 * 1. Goal Pool - Shows progress bar toward a specific goal
 * 2. Open Pool - Shows cumulative visual that grows with contributions
 */

import React from 'react';

// Format large numbers in simplified form (e.g., 2.9K, 3.1M)
const formatNumber = num => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
};

function PoolDisplay({ post, onProgressBarClick }) {
  const hasGoal = post.goal_amount && post.goal_amount > 0;
  const currentAmount = post.current_amount || 0;
  const giftCount = post.gift_count || 0;

  if (hasGoal) {
    const pct = Math.min((currentAmount / post.goal_amount) * 100, 100);
    // Goal Pool - "Mission" View with progress bar
    return (
      <div className="mb-4">
        <div className="flex items-center justify-between mb-1.5">
          <p className="text-xs font-semibold text-indigo-600">
            ${formatNumber(Math.round(currentAmount))} raised
          </p>
          <p className="text-xs text-gray-400">
            {Math.round(pct)}% of ${formatNumber(Math.round(post.goal_amount))} goal
          </p>
        </div>
        <button
          onClick={onProgressBarClick}
          className="w-full bg-gray-200 rounded-full h-4 block hover:opacity-90 transition-opacity cursor-pointer overflow-hidden"
          aria-label="Show gifters"
        >
          <div
            className="bg-gradient-to-r from-indigo-400 to-indigo-600 h-4 rounded-full transition-all duration-500 ease-out relative"
            style={{ width: `${pct}%` }}
          >
            {pct >= 8 && (
              <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] font-bold text-white leading-none">
                {giftCount} {giftCount === 1 ? 'gift' : 'gifts'}
              </span>
            )}
          </div>
        </button>
      </div>
    );
  } else {
    // Open Pool - No visual display needed
    // The engagement metrics already show gifter count and amount
    return null;
  }
}

export default PoolDisplay;
